import { SalesRoutingModule } from './sales-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { SalesScheduleDashboardComponent } from './sales-schedule-dashboard/sales-schedule-dashboard.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SalesRoutingModule,
    SharedModule,
    TranslateModule
  ],
   exports:[TranslateModule],
})
export class SalesModule { }
